@if(data()) {
  <div
    [ngStyle]="{
    position: 'relative',
    width: '100%',
    'padding-top': containerPadding + '%'
  }">
    <img
      [ngSrc]="data().data.url"
      (load)="onImageLoad($event)"
      priority
      fill
      style="object-fit: contain;"
      alt="Bildbeschreibung">
  </div>

}
